import { Eyebrow } from "../ui/Eyebrow";
import { Highlight } from "../ui/Heading";
import { HexButton } from "../ui/HexButton";
import { LINKS } from "../data/links";

export function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-bg grain-dark pt-32 pb-24 px-8">
      <div className="mx-auto max-w-[1280px] text-center flex flex-col items-center">
        <Eyebrow>Stop closing in chaos</Eyebrow>

        <div className="mt-10 h-2 w-40 hatch-accent" />

        <p className="mt-12 max-w-[880px] font-display italic font-extrabold text-[clamp(36px,5vw,64px)] leading-[1.05] tracking-tight text-td-1 [text-wrap:balance]">
          You've got <Highlight>3 deals going cold</Highlight> right now.
          <br className="max-md:hidden" />
          {" "}You just don't know it yet.
        </p>

        <div className="mt-10 flex justify-center">
          <HexButton variant="primary" size="lg" href={LINKS.setup}>
            Book a setup call
          </HexButton>
        </div>

        <p className="mt-10 font-mono text-xs tracking-wider text-td-3">
          DEDICATED MICROVM · BYOK · TELEGRAM SEND OPT-IN · CANCEL ANYTIME
        </p>
      </div>
    </section>
  );
}
